/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function () {
  function isReloadNavigation() {
    try {
      if (typeof performance.getEntriesByType === 'function') {
        var entries = performance.getEntriesByType('navigation');
        if (entries && entries[0] && entries[0].type === 'reload') return true;
      }
    } catch (e) {}
    try {
      if (performance.navigation && performance.navigation.type === 1) return true;
    } catch (e2) {}
    return false;
  }

  function enableManualScrollRestoration() {
    try {
      if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
      }
    } catch (e) {}
  }

  function reloadScrollTop() {
    if (!isReloadNavigation()) return;
    enableManualScrollRestoration();
    window.scrollTo(0, 0);
  }

  /*
   * Reset scroll to top on reload EARLY only. With scrollRestoration = 'manual', the browser
   * already starts a reload at the top, so we don't fire window.scrollTo(0,0) on the late
   * `load` / `pageshow` events — those ran after the hero video/images finished downloading and
   * snapped the user back up if they had already started scrolling (most visible on mobile).
   */
  enableManualScrollRestoration();
  reloadScrollTop();
  document.addEventListener('DOMContentLoaded', reloadScrollTop);
})();

jQuery(document).ready(function ($) {
  // Only init the ticker when the markup is present; otherwise the plugin logs an
  // INITIALIZATION ERROR to the console on every page (no .text-slide element ships).
  if ($(".text-slide").length) {
    $(".text-slide").jConveyorTicker({
      anim_duration: 200,
      reverse_elm: false,
    });
  }
  $(".faq-wrapper .accordion .title").on("click", function () {
    $(this).closest(".accordion").toggleClass("active");
    
  });

  $(".product-meta .product-meta__reviews-badge, .hmc-pdp-revamp-hero .product-meta__reviews-badge").on(
    "click keydown",
    function (e) {
      if (e.type === "keydown" && e.key !== "Enter" && e.key !== " ") {
        return;
      }
      e.preventDefault();
      var $badge = $(this);
      var offset = parseInt($badge.data("offset"), 10);
      if (isNaN(offset)) {
        offset =
          window.matchMedia &&
          window.matchMedia("(max-width: 999px)").matches
            ? 56
            : 30;
      }

      function scrollToReviewsWidget() {
        var $t = $("#hmc-pdp-customer-reviews").length
          ? $("#hmc-pdp-customer-reviews")
          : $("#judgeme_product_reviews");
        if ($t.length && $t.offset()) {
          $("html, body").animate(
            {
              scrollTop: Math.max(0, $t.offset().top - offset),
            },
            650
          );
        }
      }

      /* 4Runner / Judge.me anchor is always on-page — don’t trigger legacy tab widget (#tabs-5). */
      if ($("#hmc-pdp-customer-reviews").length || $("#judgeme_product_reviews").length) {
        scrollToReviewsWidget();
        return;
      }

      $(".reviews_tab").trigger("click");
      setTimeout(scrollToReviewsWidget, 500);
    }
  );

  $(window).on('load', () => {
        const element = $('.quote-image-slider');
        const mediaQuery = window.matchMedia('(max-width: 1052px)');

        const handleSwitchSlick = ((e) => {
            if (e.matches) {
                element.slick({
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    infinite: true,
                    arrows: false,
                    dots: true

                });
            } else if (element.hasClass('slick-initialized')) {
                element.slick('unslick');
            }
        });

        mediaQuery.addListener(handleSwitchSlick);
        handleSwitchSlick(mediaQuery);
    });


  $('.timeline-main-slider').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
    dots: false,
  asNavFor: '.timeline-control-slider'
});
$('.timeline-control-slider').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor: '.timeline-main-slider',
  dots: false,
   arrows: false,
  centerMode: true,
  focusOnSelect: true,
   responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }
  ]
});
if($('.accordion-manual').length) {
  $(".accordion-manual .section__header").on("click", function () {
    $(this).closest(".accordion-manual").toggleClass("active");
    
  });
}
  
});

/**
 * Judge.me preview badges on PLP: collection filter AJAX replaces the grid without a full page load,
 * so the embed must re-scan. Also nudge hydration after window load (Judge script loads async).
 */
(function initHmcJudgemePreviewBadgeReload() {
  function tryReloadJudgemePreviews() {
    try {
      if (window.jdgm && typeof window.jdgm.run === "function") {
        window.jdgm.run();
      }
    } catch (e) {}
    try {
      if (window.jdgm_api && typeof window.jdgm_api.preview_badge_reload === "function") {
        window.jdgm_api.preview_badge_reload();
      }
    } catch (e) {}
    try {
      if (typeof window.jdgm_reload_preview_badge === "function") {
        window.jdgm_reload_preview_badge();
      }
    } catch (e) {}
    try {
      if (window.jQuery && typeof window.jQuery.fn.jdgm_loadBadges === "function") {
        window.jQuery(".jdgm-widget.jdgm-preview-badge").jdgm_loadBadges();
      }
    } catch (e) {}
  }

  function isEmptyJudgemeBadgeEl(badge) {
    if (!badge) {
      return true;
    }
    var count = parseInt(badge.getAttribute("data-number-of-reviews") || "0", 10);
    var avg = parseFloat(badge.getAttribute("data-average-rating") || "0");
    var hasContent = badge.querySelector(".jdgm-prev-badge, .rating__stars");
    return !hasContent && count === 0 && (isNaN(avg) || avg === 0);
  }

  function hideEmptyHmcReviewBadges() {
    document
      .querySelectorAll(
        "section.hmc-pdp-revamp .hmc-pdp-revamp-hero__reviews-early, section.hmc-pdp-revamp .product-meta__reviews-badge, .product-item__reviews-badge, .product-meta__reviews-badge"
      )
      .forEach(function (wrap) {
        if (wrap.querySelector(".hmc-reviews-badge--no-rating")) {
          wrap.classList.remove("hmc-reviews-badge--empty");
          return;
        }
        var badge = wrap.querySelector(".jdgm-preview-badge, .hmc-judgeme-badge-root");
        if (!badge || isEmptyJudgemeBadgeEl(badge)) {
          wrap.classList.add("hmc-reviews-badge--empty");
        } else {
          wrap.classList.remove("hmc-reviews-badge--empty");
        }
      });
  }

  /** Judge.me async inject can add orphan widgets on PLP cards with zero reviews. */
  function tidyProductItemsWithoutReviews() {
    document.querySelectorAll(".product-item--no-reviews").forEach(function (item) {
      item.querySelectorAll(".product-item__info-inner .jdgm-preview-badge, .product-item__info-inner .jdgm-widget").forEach(
        function (badge) {
          if (isEmptyJudgemeBadgeEl(badge)) {
            badge.style.display = "none";
            var wrap = badge.closest(".product-item__reviews-badge");
            if (wrap && !wrap.querySelector(".hmc-reviews-badge--no-rating")) {
              wrap.classList.add("hmc-reviews-badge--empty");
            }
          }
        }
      );
    });
  }

  function reloadJudgemeAndTidyBadges() {
    tryReloadJudgemePreviews();
    window.setTimeout(function () {
      hideEmptyHmcReviewBadges();
      tidyProductItemsWithoutReviews();
    }, 50);
    window.setTimeout(function () {
      hideEmptyHmcReviewBadges();
      tidyProductItemsWithoutReviews();
    }, 400);
  }

  var is4rRevampPdp =
    document.body.classList.contains("hmc-pdp-4runner-revamp") &&
    document.body.classList.contains("template-product");

  document.addEventListener("DOMContentLoaded", function () {
    hideEmptyHmcReviewBadges();
    tidyProductItemsWithoutReviews();
    if (is4rRevampPdp) {
      window.setTimeout(reloadJudgemeAndTidyBadges, 500);
      return;
    }
    window.setTimeout(reloadJudgemeAndTidyBadges, 400);
    window.setTimeout(reloadJudgemeAndTidyBadges, 2200);
  });

  document.addEventListener("theme:loading:end", function () {
    if (is4rRevampPdp) {
      window.setTimeout(reloadJudgemeAndTidyBadges, 150);
      return;
    }
    window.setTimeout(tryReloadJudgemePreviews, 100);
    window.setTimeout(tryReloadJudgemePreviews, 700);
    window.setTimeout(hideEmptyHmcReviewBadges, 100);
    window.setTimeout(hideEmptyHmcReviewBadges, 700);
    window.setTimeout(reloadJudgemeAndTidyBadges, 100);
    window.setTimeout(reloadJudgemeAndTidyBadges, 700);
  });

  window.addEventListener("load", function () {
    if (is4rRevampPdp) {
      window.setTimeout(reloadJudgemeAndTidyBadges, 400);
      return;
    }
    window.setTimeout(tryReloadJudgemePreviews, 0);
    window.setTimeout(tryReloadJudgemePreviews, 1500);
    window.setTimeout(hideEmptyHmcReviewBadges, 0);
    window.setTimeout(hideEmptyHmcReviewBadges, 1500);
    window.setTimeout(reloadJudgemeAndTidyBadges, 0);
    window.setTimeout(reloadJudgemeAndTidyBadges, 1500);
  });
})();


/**
 * Footer (hmc hero): when scrolled into view, fade blocks up (see custom.css .hmc-footer-hero--visible).
 */
(function initHmcFooterHeroScrollReveal() {
  var footerObserver = null;

  function revealFooters() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('footer.footer--hmc-hero').forEach(function (el) {
        el.classList.add('hmc-footer-hero--visible');
      });
      return;
    }

    if (!footerObserver) {
      footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var el = entry.target;

            if (!entry.isIntersecting) {
              var pendingId = el.dataset.hmcFooterRevealTid;
              if (pendingId) {
                window.clearTimeout(parseInt(pendingId, 10));
                delete el.dataset.hmcFooterRevealTid;
              }
              return;
            }

            if (el.classList.contains('hmc-footer-hero--visible')) {
              return;
            }
            if (el.dataset.hmcFooterRevealTid) {
              return;
            }

            var tid = window.setTimeout(function () {
              delete el.dataset.hmcFooterRevealTid;
              if (!el.classList.contains('hmc-footer-hero--visible')) {
                el.classList.add('hmc-footer-hero--visible');
                footerObserver.unobserve(el);
                delete el.dataset.hmcFooterIoObserved;
              }
            }, 220);

            el.dataset.hmcFooterRevealTid = String(tid);
          });
        },
        {
          root: null,
          rootMargin: '0px 0px -14% 0px',
          threshold: 0.07,
        }
      );
    }

    document.querySelectorAll('footer.footer--hmc-hero:not(.hmc-footer-hero--visible)').forEach(function (el) {
      if (el.dataset.hmcFooterIoObserved === '1') {
        return;
      }
      el.dataset.hmcFooterIoObserved = '1';
      footerObserver.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', revealFooters);
  } else {
    revealFooters();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (ev.target && ev.target.querySelector && ev.target.querySelector('footer.footer--hmc-hero')) {
      revealFooters();
    }
  });
})();

document.querySelectorAll('.scroll-link').forEach(function (link) {
  link.addEventListener('click', function (e) {
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    e.preventDefault();
    var targetId = href.slice(1);
    var targetElement = document.getElementById(targetId);
    if (!targetElement) return;
    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
});

/*
 * Homepage CarPlay rails: left/right buttons for horizontal product rows.
 */
(function initHomeCarplayRailButtons() {
  function bindRail(railWrap) {
    if (!railWrap || railWrap.dataset.hmcRailButtonsReady === '1') return;

    var list = railWrap.querySelector('.hmc-home-carplay-make-rows__product-list');
    var prevBtn = railWrap.querySelector('[data-hmc-make-rail-prev]');
    var nextBtn = railWrap.querySelector('[data-hmc-make-rail-next]');
    if (!list || !prevBtn || !nextBtn) return;

    railWrap.dataset.hmcRailButtonsReady = '1';

    function scrollAmount() {
      var first = list.querySelector('.product-item');
      if (!first) return Math.max(220, Math.floor(list.clientWidth * 0.8));
      var style = window.getComputedStyle(list);
      var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
      return first.getBoundingClientRect().width + gap;
    }

    function updateButtons() {
      var max = Math.max(0, list.scrollWidth - list.clientWidth);
      var left = list.scrollLeft;
      prevBtn.disabled = left <= 2;
      nextBtn.disabled = left >= max - 2;
      railWrap.classList.toggle('is-at-start', prevBtn.disabled);
      railWrap.classList.toggle('is-at-end', nextBtn.disabled);
      railWrap.classList.toggle('has-overflow', max > 2);
    }

    function scrollByDir(dir) {
      list.scrollBy({ left: dir * scrollAmount(), behavior: 'smooth' });
    }

    prevBtn.addEventListener('click', function () {
      scrollByDir(-1);
    });
    nextBtn.addEventListener('click', function () {
      scrollByDir(1);
    });
    list.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    updateButtons();
  }

  function bindAll() {
    var rails = document.querySelectorAll(
      '[data-section-type=\"hmc-home-carplay-make-rows\"] [data-hmc-make-rail]'
    );
    rails.forEach(bindRail);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target || !ev.target.querySelector) return;
    var rails = ev.target.querySelectorAll('[data-hmc-make-rail]');
    rails.forEach(bindRail);
  });
})();

(function () {
  function insertReviewsAnchor() {
    if (!document.body.classList.contains('hmc-pdp-4runner-revamp')) return;
    if (document.getElementById('hmc-pdp-customer-reviews')) return;
    var sections = document.querySelectorAll('main#main [id^="shopify-section-"]');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (
        sec.querySelector(
          '[id^="stamped-"], .stamped-main-widget, #judgeme_product_reviews, .jdgm-review-widget'
        )
      ) {
        var anchor = document.createElement('div');
        anchor.id = 'hmc-pdp-customer-reviews';
        anchor.className = 'hmc-pdp-reviews-anchor';
        sec.parentNode.insertBefore(anchor, sec);
        return;
      }
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', insertReviewsAnchor);
  } else {
    insertReviewsAnchor();
  }
  document.addEventListener('shopify:section:load', insertReviewsAnchor);
})();

/*
 * 4Runner PDP Stamped carousel: normalize card DOM into stable roles so CSS layout is reliable.
 * Goal: image left, product line right, comment below product, author/meta below comment.
 */
(function () {
  if (!document.body.classList.contains('hmc-pdp-4runner-revamp')) return;

  function textOf(el) {
    return (el && el.textContent ? el.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function likelyProductLine(txt) {
    return /\b(19|20)\d{2}\s*-\s*(19|20)\d{2}\b/.test(txt) || /carplay|android|conversion|upgrade|kit/i.test(txt);
  }

  function likelyMeta(txt) {
    return /^verified\b/i.test(txt) || /^[A-Z][a-z]+(?:\s+[A-Z]\.?)?$/.test(txt);
  }

  function applyCardRoles(card) {
    if (!card || card.dataset.hmcStampedRoleReady === '1') return;
    var img = card.querySelector('img');
    if (!img) return;

    var textNodes = Array.prototype.slice.call(
      card.querySelectorAll('p, div, span, small, strong, h2, h3, h4, a, blockquote')
    ).filter(function (el) {
      if (!el || el.querySelector('img, svg, button, input')) return false;
      if (el.closest('button, [role="button"]')) return false;
      var txt = textOf(el);
      return txt.length > 0 && txt.length < 260;
    });

    if (!textNodes.length) return;

    var productEl = null;
    var commentEl = null;
    var metaEls = [];

    textNodes.forEach(function (el) {
      var txt = textOf(el);
      if (!productEl && likelyProductLine(txt)) {
        productEl = el;
        return;
      }
      if (!commentEl && txt.length >= 32 && /[.!?]/.test(txt)) {
        commentEl = el;
        return;
      }
      if (likelyMeta(txt) || txt.length <= 24) {
        metaEls.push(el);
      }
    });

    if (!productEl) {
      productEl = textNodes.find(function (el) { return textOf(el).length >= 18 && textOf(el).length <= 120; }) || null;
    }
    if (!commentEl) {
      commentEl = textNodes.find(function (el) { return el !== productEl && textOf(el).length >= 28; }) || null;
    }

    card.classList.add('hmc-stamped-card');
    img.classList.add('hmc-stamped-card__media');

    if (productEl) productEl.classList.add('hmc-stamped-card__product');
    if (commentEl) commentEl.classList.add('hmc-stamped-card__comment');
    metaEls.forEach(function (el) {
      if (el !== productEl && el !== commentEl) el.classList.add('hmc-stamped-card__meta');
    });

    card.dataset.hmcStampedRoleReady = '1';
  }

  function normalizeStampedCards() {
    var root = document.querySelector('#stamped-reviews-widget');
    if (!root) return;
    var cards = root.querySelectorAll('.slick-slide > div > *');
    cards.forEach(applyCardRoles);
  }

  var obs = null;
  function boot() {
    normalizeStampedCards();
    var root = document.querySelector('#stamped-reviews-widget');
    if (!root || obs) return;
    obs = new MutationObserver(function () { normalizeStampedCards(); });
    obs.observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
})();

/**
 * 4Runner PDP: move the HMC Mapbox store locator section into the Find Installer tab.
 * Mount only after that tab panel is visible — `hidden` on the tabpanel keeps `display:none` and the map
 * often never initializes, which leaves "Loading map…" forever.
 */
(function () {
  /** Template JSON section key; DOM id is `shopify-section-template--…__` + this suffix on OS 2.0 */
  var LOCATOR_SECTION_SUFFIX = '17376491554c9ad109';
  var MAX_ATTEMPTS = 80;
  var RETRY_MS = 200;

  function dispatchResize() {
    window.dispatchEvent(new Event('resize'));
  }

  function findLocatorAppsSection() {
    var byLegacy = document.getElementById('shopify-section-' + LOCATOR_SECTION_SUFFIX);
    if (byLegacy) return byLegacy;
    return document.querySelector(
      '[id^="shopify-section-"][id$="__' + LOCATOR_SECTION_SUFFIX + '"]'
    );
  }

  function getTabsContext() {
    if (!document.body.classList.contains('hmc-pdp-4runner-revamp')) return null;
    var tabsRoot = document.querySelector('[data-hmc-pdp-tabs][data-hmc-locator-section-id]');
    if (!tabsRoot || !tabsRoot.id || tabsRoot.id.indexOf('hmc-pdp-tabs-') !== 0) return null;
    var mainSectionId = tabsRoot.id.replace('hmc-pdp-tabs-', '');
    var mount = document.getElementById('hmc-pdp-installer-embed-mount-' + mainSectionId);
    var sourceSection = findLocatorAppsSection();
    if (!mount || !sourceSection) return null;
    return { mainSectionId: mainSectionId, mount: mount, sourceSection: sourceSection };
  }

  function installerPanelVisible(mainSectionId) {
    var panel = document.getElementById('hmc-pdp-panel-installer-' + mainSectionId);
    return !!(panel && !panel.hasAttribute('hidden'));
  }

  function tryMountStoreLocator(attempt, opts) {
    opts = opts || {};
    var force = opts.force === true;
    var ctx = getTabsContext();
    if (!ctx) return;

    var mount = ctx.mount;
    var sourceSection = ctx.sourceSection;
    var mainSectionId = ctx.mainSectionId;

    if (mount.dataset.hmcLocatorMounted === '1') {
      if (force) {
        dispatchResize();
        setTimeout(dispatchResize, 400);
      }
      return;
    }

    if (!force && !installerPanelVisible(mainSectionId)) return;

    var n = typeof attempt === 'number' ? attempt : 0;
    var shell =
      sourceSection.querySelector('[data-hmc-store-locator-shell]') ||
      sourceSection.querySelector('.hmc-store-locator__shell') ||
      sourceSection.querySelector('.container');
    if (!shell || !shell.parentNode) {
      if (n < MAX_ATTEMPTS) setTimeout(function () { tryMountStoreLocator(n + 1, opts); }, RETRY_MS);
      return;
    }

    if (shell.childElementCount === 0 && n < MAX_ATTEMPTS) {
      setTimeout(function () { tryMountStoreLocator(n + 1, opts); }, RETRY_MS);
      return;
    }
    if (shell.childElementCount === 0) return;

    mount.appendChild(shell);
    mount.dataset.hmcLocatorMounted = '1';
    mount.classList.add('hmc-pdp-installer-tab__mount--locator-ready');
    sourceSection.classList.add('hmc-store-locator-source--empty');
    try {
      mount.dispatchEvent(new CustomEvent('hmc-store-locator-mounted', { bubbles: true }));
    } catch (e) {}
    dispatchResize();
    setTimeout(dispatchResize, 400);
    setTimeout(dispatchResize, 1200);
  }

  function wireInstallerTabMount(mainSectionId) {
    var tab = document.getElementById('hmc-pdp-tab-installer-' + mainSectionId);
    if (!tab || tab.dataset.hmcLocatorMountWired === '1') return;
    tab.dataset.hmcLocatorMountWired = '1';
    tab.addEventListener('click', function () {
      window.setTimeout(function () {
        tryMountStoreLocator(0, { force: true });
      }, 0);
    });
  }

  function pruneInstallerTabIfNoLocatorSection() {
    if (!document.body.classList.contains('hmc-pdp-4runner-revamp')) return;
    var tabsRoot = document.querySelector('[data-hmc-pdp-tabs]');
    if (!tabsRoot || !tabsRoot.id || tabsRoot.id.indexOf('hmc-pdp-tabs-') !== 0) return;
    var mainSectionId = tabsRoot.id.replace('hmc-pdp-tabs-', '');
    if (findLocatorAppsSection()) return;
    var tab = document.getElementById('hmc-pdp-tab-installer-' + mainSectionId);
    var panel = document.getElementById('hmc-pdp-panel-installer-' + mainSectionId);
    if (tab && tab.parentNode) tab.parentNode.removeChild(tab);
    if (panel && panel.parentNode) panel.parentNode.removeChild(panel);
    if (!tabsRoot.querySelector('.hmc-pdp-tabs__tab')) {
      try {
        tabsRoot.style.display = 'none';
      } catch (e) {}
    }
  }

  function boot() {
    pruneInstallerTabIfNoLocatorSection();
    var ctx = getTabsContext();
    if (!ctx) return;
    wireInstallerTabMount(ctx.mainSectionId);
    tryMountStoreLocator(0, { force: installerPanelVisible(ctx.mainSectionId) });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    if (!ev || !ev.target || !ev.target.id) return;
    var sid = ev.target.id;
    if (sid !== 'shopify-section-' + LOCATOR_SECTION_SUFFIX && !sid.endsWith('__' + LOCATOR_SECTION_SUFFIX)) return;
    var ctx = getTabsContext();
    if (!ctx) return;
    ctx.mount.innerHTML = '';
    delete ctx.mount.dataset.hmcLocatorMounted;
    ctx.mount.classList.remove('hmc-pdp-installer-tab__mount--locator-ready');
    ev.target.classList.remove('hmc-store-locator-source--empty');
    tryMountStoreLocator(0, { force: installerPanelVisible(ctx.mainSectionId) });
  });
})();

/**
 * One-shot: remove legacy `.hmc-jdgm-toolbar-row` wrappers if still in DOM (Judge.me toolbar
 * customization was disabled — see `layout/theme.liquid` + git history for `hmc-judgeme-reviews.css`).
 */
(function () {
  function unwrapJudgemeToolbars() {
    document.querySelectorAll('.hmc-jdgm-toolbar-row').forEach(function (wrap) {
      var p = wrap.parentNode;
      if (!p) return;
      while (wrap.firstChild) {
        p.insertBefore(wrap.firstChild, wrap);
      }
      try {
        p.removeChild(wrap);
      } catch (e) {}
    });
  }

  function run() {
    unwrapJudgemeToolbars();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', run);
})();

/**
 * PDP (all products, mobile price row): dedupe Shop Pay / legacy price row noise.
 * Shopify can inject a second `shopify-payment-terms` or leave the old `.product-form__info-item` in DOM briefly.
 */
(function () {
  var buyColMo = null;
  var shopPayRootMo = null;
  var shopPayWatchersDisconnected = false;

  function isHmcProductPdp() {
    return document.body.classList.contains('template-product');
  }

  function getBuyCol() {
    return document.querySelector(
      'section.hmc-pdp-revamp .product-block-list__item--info, .template-product .product-block-list__item--info'
    );
  }

  function getPriceShopClip() {
    return document.querySelector('[data-hmc-shop-pay-clip]');
  }

  function disconnectShopPayWatchers() {
    shopPayWatchersDisconnected = true;
    if (buyColMo) {
      try {
        buyColMo.disconnect();
      } catch (e) {}
      buyColMo = null;
    }
    if (shopPayRootMo) {
      try {
        shopPayRootMo.disconnect();
      } catch (e) {}
      shopPayRootMo = null;
    }
  }

  function resetShopPayWatchers() {
    shopPayWatchersDisconnected = false;
    var buyCol = document.querySelector('section.hmc-pdp-revamp .product-block-list__item--info');
    if (buyCol) {
      delete buyCol.dataset.hmcShopPaySettled;
    }
    document.querySelectorAll('shopify-payment-terms').forEach(function (terms) {
      delete terms.dataset.hmcShopPayTuned;
      delete terms.dataset.hmcShopPayTuneMo;
    });
  }

  function trySettleShopPayWatchers(buyCol, termsSlot) {
    if (shopPayWatchersDisconnected || !buyCol || !termsSlot) return;

    var payNode = termsSlot.querySelector('shopify-payment-terms');
    if (!payNode || payNode.dataset.hmcShopPayTuned !== '1') return;

    var shadow = payNode.shadowRoot;
    if (!shadow || !shadow.childElementCount) return;

    buyCol.dataset.hmcShopPaySettled = '1';
    disconnectShopPayWatchers();
  }

  function tuneShopPayTermsWidget(terms) {
    if (!terms) return;

    if (typeof window.hmcTuneShopPayTerms === 'function') {
      window.hmcTuneShopPayTerms(terms);
      return;
    }
  }

  /** Lift `shopify-payment-terms` out of JSS shells so layout CSS does not zero-height the widget. */
  function promoteShopPayTermsInClip(clip) {
    if (!clip) return;

    if (typeof window.hmcPromoteShopPayInClip === 'function') {
      window.hmcPromoteShopPayInClip(clip);
      return;
    }

    if (!clip.querySelectorAll) return;

    clip.querySelectorAll('div.jss1.jss2').forEach(function (jss) {
      var pay = jss.querySelector('shopify-payment-terms');
      if (!pay) {
        jss.remove();
        return;
      }
      if (pay.parentElement !== clip) {
        clip.insertBefore(pay, jss);
      }
      jss.remove();
    });
  }

  function cleanupBuyColumnGap() {
    if (!isHmcProductPdp()) return;

    var buyCol = getBuyCol();
    var termsSlot = getPriceShopClip();
    if (!buyCol || !termsSlot) return;

    var settled = shopPayWatchersDisconnected || buyCol.dataset.hmcShopPaySettled === '1';
    var hero = termsSlot.closest('.hmc-pdp-revamp-hero');
    var buyIntro = termsSlot.closest('.hmc-pdp-revamp-hero__buy-intro');
    var desc = buyCol.querySelector('.product-description--metafield');

    if (settled) {
      if (termsSlot) {
        var heroPaySettled = termsSlot.querySelector('shopify-payment-terms');

        buyCol.querySelectorAll('shopify-payment-terms').forEach(function (node) {
          if (termsSlot.contains(node)) return;

          if (!heroPaySettled) {
            termsSlot.appendChild(node);
            heroPaySettled = node;
            return;
          }

          node.remove();
        });

        termsSlot.querySelectorAll('div.jss1.jss2').forEach(function (el) {
          if (!el.querySelector('shopify-payment-terms')) el.remove();
        });
      }

      return;
    }

    if (buyIntro) {
      buyIntro.querySelectorAll('.hmc-pdp-shop-pay-clip').forEach(promoteShopPayTermsInClip);
      buyIntro.querySelectorAll('div.jss1.jss2').forEach(function (el) {
        el.remove();
      });

      Array.prototype.forEach.call(buyIntro.children, function (child) {
        if (child.classList.contains('hmc-pdp-revamp-hero__price-shop-row')) return;
        if (child.classList.contains('product-description--metafield')) return;
        child.remove();
      });
    }

    if (termsSlot) {
      var heroPay = termsSlot.querySelector('shopify-payment-terms');

      buyCol.querySelectorAll('shopify-payment-terms').forEach(function (node) {
        if (termsSlot.contains(node)) return;

        if (!heroPay) {
          termsSlot.appendChild(node);
          heroPay = node;
          return;
        }

        node.remove();
      });
    }

    if (termsSlot.closest('.hmc-pdp-revamp-hero__price-shop-row') && desc) {
      var node = desc.previousElementSibling;

      while (node && !hero.contains(node)) {
        var prev = node.previousElementSibling;

        if (
          node.tagName === 'SHOPIFY-PAYMENT-TERMS' ||
          (node.classList && node.classList.contains('product-form__info-item'))
        ) {
          node.remove();
        }

        node = prev;
      }
    }

    buyCol.querySelectorAll('.product-meta--hmc-revamp-tail').forEach(function (tail) {
      tail.setAttribute('aria-hidden', 'true');
    });

    /* Shop Pay JSS placeholder (`motion.div.jss1.jss2`, ~40px) — remove; widget is `shopify-payment-terms` only. */
    buyCol.querySelectorAll('div.jss1.jss2').forEach(function (el) {
      if (el.querySelector('shopify-payment-terms')) return;
      el.remove();
    });

    if (termsSlot) {
      promoteShopPayTermsInClip(termsSlot);

      termsSlot.querySelectorAll('div.jss1.jss2').forEach(function (el) {
        el.remove();
      });

      var payNode = termsSlot.querySelector('shopify-payment-terms');
      if (payNode) {
        tuneShopPayTermsWidget(payNode);
      }

      var sib = payNode ? payNode.nextElementSibling : null;

      while (sib) {
        var next = sib.nextElementSibling;

        if (sib.classList && sib.classList.contains('jss1') && sib.classList.contains('jss2')) {
          sib.remove();
        }

        sib = next;
      }

      trySettleShopPayWatchers(buyCol, termsSlot);

      if (typeof window.hmcRevealShopPayClip === 'function' && termsSlot) {
        window.hmcRevealShopPayClip(termsSlot);
      }
    }

    if (desc) {
      var ghost = desc.previousElementSibling;

      while (ghost && (!hero || !hero.contains(ghost))) {
        var prevGhost = ghost.previousElementSibling;

        if (ghost.classList && ghost.classList.contains('jss1') && ghost.classList.contains('jss2')) {
          ghost.remove();
        }

        ghost = prevGhost;
      }
    }

  }

  function watchShopPayJssGhosts() {
    if (
      shopPayWatchersDisconnected ||
      !isHmcProductPdp() ||
      !('MutationObserver' in window) ||
      shopPayRootMo
    ) {
      return;
    }

    var termsSlot = getPriceShopClip();
    var root = termsSlot ? termsSlot.parentElement : null;

    if (!root) return;

    shopPayRootMo = new MutationObserver(schedule);

    try {
      shopPayRootMo.observe(root, { childList: true, subtree: true });
    } catch (e) {
      shopPayRootMo = null;
    }
  }

  var raf = null;
  function schedule(immediate) {
    if (immediate) {
      if (raf) {
        cancelAnimationFrame(raf);
        raf = null;
      }
      cleanupBuyColumnGap();
      return;
    }

    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = null;
      cleanupBuyColumnGap();
    });
  }

  function bootShopPayRow() {
    if (typeof window.hmcBootHeroShopPay === 'function') {
      window.hmcBootHeroShopPay();
    }
    schedule(true);
    watchShopPayJssGhosts();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootShopPayRow);
  } else {
    bootShopPayRow();
  }

  window.addEventListener('load', schedule, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    resetShopPayWatchers();
    bootShopPayRow();
    bindBuyColShopPayObserver();
  });

  function bindBuyColShopPayObserver() {
    if (shopPayWatchersDisconnected || buyColMo || !('MutationObserver' in window)) return;

    var root = getBuyCol();
    if (!root || root.dataset.hmcShopPaySettled === '1') return;

    buyColMo = new MutationObserver(schedule);

    try {
      buyColMo.observe(root, { childList: true, subtree: true });
    } catch (e) {
      buyColMo = null;
    }
  }

  bindBuyColShopPayObserver();

  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    window.customElements.whenDefined('shopify-payment-terms').then(function () {
      schedule(true);
    });
  }

  [16, 32, 50, 100, 200, 400].forEach(function (ms) {
    window.setTimeout(function () {
      schedule(ms <= 50);
    }, ms);
  });
})();

/**
 * 4Runner revamp PDP: Shopify hydrates `delivery-promise-wc` beside payment terms / in the form.
 * `.hmc-pdp-shop-pay-clip` intentionally zero-heights anything that is not `shopify-payment-terms`, so the
 * “Arrives…” line must live under ATC — in `.hmc-pdp-revamp-post-atc-stack` (all breakpoints).
 */
(function () {
  var MOBILE_MQ = '(max-width: 749px)';

  var NARROW_DELIVERY_MQ = '(max-width: 999px)';

  function reorderHmcPdpDeliveryIntoPostAtcStack() {
    if (!document.body.classList.contains('hmc-pdp-4runner-revamp') || !document.body.classList.contains('template-product')) {
      return;
    }
    var stack = document.querySelector('section.hmc-pdp-revamp .hmc-pdp-revamp-post-atc-stack');
    var form = document.querySelector('section.hmc-pdp-revamp .product-form');
    if (!form) return;

    var narrow = false;
    try {
      narrow = window.matchMedia(NARROW_DELIVERY_MQ).matches;
    } catch (e) {}

    var trust = document.querySelector('section.hmc-pdp-revamp .hmc-pdp-atc-trust-strip');
    var share = document.querySelector('section.hmc-pdp-revamp .hmc-pdp-revamp-share--after-spark');
    var deliveries = form.querySelectorAll('delivery-promise-wc');

    for (var i = 0; i < deliveries.length; i++) {
      var d = deliveries[i];

      if (narrow && trust) {
        if (trust.nextElementSibling !== d) {
          trust.insertAdjacentElement('afterend', d);
        }
        continue;
      }

      if (!stack) continue;

      if (share && stack.contains(share)) {
        if (d.parentElement !== stack || d.nextElementSibling !== share) {
          stack.insertBefore(d, share);
        }
      } else if (!stack.contains(d)) {
        stack.appendChild(d);
      }
    }
  }

  var raf = null;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = null;
      reorderHmcPdpDeliveryIntoPostAtcStack();
      try {
        window.dispatchEvent(new CustomEvent('hmc:pdp-delivery-slot-updated'));
      } catch (e) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  var form = document.querySelector('section.hmc-pdp-revamp .product-form');
  if (form && 'MutationObserver' in window) {
    var mo = new MutationObserver(function () {
      schedule();
    });
    try {
      mo.observe(form, { childList: true, subtree: true });
    } catch (e) {}
  }

  try {
    var mq = window.matchMedia(MOBILE_MQ);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    else if (mq.addListener) mq.addListener(schedule);
  } catch (e) {}
  try {
    var narrowMq = window.matchMedia(NARROW_DELIVERY_MQ);
    if (narrowMq.addEventListener) narrowMq.addEventListener('change', schedule);
    else if (narrowMq.addListener) narrowMq.addListener(schedule);
  } catch (e2) {}
  window.addEventListener('resize', schedule, { passive: true });
})();

/**
 * Move theme modals to document.body so position:fixed centering is relative to the viewport,
 * not a transformed PDP buy column (scale() makes popups drift left / clip on small windows).
 */
(function () {
  function portalModals(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var modals = scope.querySelectorAll ? scope.querySelectorAll('.modal') : [];

    for (var i = 0; i < modals.length; i++) {
      var modal = modals[i];
      if (!modal || modal.parentNode === document.body) continue;
      document.body.appendChild(modal);
    }
  }

  function run() {
    portalModals(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  document.addEventListener('shopify:section:load', function (event) {
    portalModals(event.target || document);
  });
})();

/**
 * CarPlay kit collection PLP (desktop): keep the left filter card visible while scrolling.
 * CSS position:sticky is unreliable here (flex ancestors, overflow); use fixed + placeholder instead.
 */
(function () {
  var DESKTOP_MQ = '(min-width: 1000px)';
  var PH_CLASS = 'hmc-carplay-filter-dock-placeholder';
  var DOCKED_CLASS = 'hmc-carplay-filter-docked';
  var BOTTOMED_CLASS = 'hmc-carplay-filter-bottomed';
  var GAP_PX = 16;
  var BOTTOM_GAP_PX = 10;
  var mq = null;
  var raf = null;

  function isCarplayCollection() {
    return (
      document.body.classList.contains('hmc-collection-carplay-kits') &&
      document.body.classList.contains('template-collection')
    );
  }

  function getShell() {
    return document.querySelector('body.hmc-collection-carplay-kits .layout__section--large-secondary');
  }

  function cssVarPx(varName) {
    try {
      var probe = document.createElement('div');
      probe.style.position = 'fixed';
      probe.style.top = 'var(' + varName + ')';
      probe.style.left = '0';
      probe.style.width = '1px';
      probe.style.height = '1px';
      probe.style.pointerEvents = 'none';
      probe.style.visibility = 'hidden';
      document.body.appendChild(probe);
      var topStr = window.getComputedStyle(probe).top || '';
      try {
        document.body.removeChild(probe);
      } catch (e) {}
      var n = parseFloat(topStr);
      if (!isNaN(n) && n > 0) {
        return Math.round(n);
      }
    } catch (e) {}
    return null;
  }

  function fixedChromeBottomPx() {
    var maxBottom = 0;
    try {
      var ann = document.querySelector('section[data-section-type="announcement-bar"]');
      var annWrap = ann && ann.closest && ann.closest('.shopify-section');
      if (annWrap) {
        var r1 = annWrap.getBoundingClientRect();
        if (r1 && r1.height > 2) maxBottom = Math.max(maxBottom, r1.bottom);
      }
    } catch (e) {}

    try {
      var bfb = document.querySelector('#black-friday-banner-container');
      if (bfb) {
        var r2 = bfb.getBoundingClientRect();
        if (r2 && r2.height > 2) maxBottom = Math.max(maxBottom, r2.bottom);
      }
    } catch (e) {}

    try {
      var hdrWrap =
        document.querySelector('#shopify-section-header') ||
        document.querySelector('.shopify-section:has(> section[data-section-type="header"])') ||
        null;
      if (hdrWrap) {
        var rw = hdrWrap.getBoundingClientRect();
        if (rw && rw.height > 2) maxBottom = Math.max(maxBottom, rw.bottom);
      }
    } catch (e) {}

    try {
      var hdr =
        document.querySelector('section[data-section-type="header"] header.header') ||
        document.querySelector('header.header');
      if (hdr) {
        var els = [hdr];
        try {
          var nav = hdr.querySelector('.nav-bar');
          if (nav) els.push(nav);
        } catch (e) {}
        try {
          var inner = hdr.querySelector('.header__inner');
          if (inner) els.push(inner);
        } catch (e) {}
        for (var i = 0; i < els.length; i++) {
          var r3 = els[i] && els[i].getBoundingClientRect && els[i].getBoundingClientRect();
          if (r3 && r3.height > 2) maxBottom = Math.max(maxBottom, r3.bottom);
        }
      }
    } catch (e) {}

    if (maxBottom > 0) return Math.round(maxBottom);
    return null;
  }

  /** Viewport Y (px) where the filter card top should sit when docked: just under fixed header + gap. */
  function dockTopPx() {
    /* Prefer CSS-driven chrome math so we match the page's own offsets. */
    var cssTop = cssVarPx('--hmc-carplay-filter-sticky-top');

    /* Clamp to at least the measured chrome stack bottom + GAP (safety). */
    var chromeBottom = fixedChromeBottomPx();
    var measuredMin = chromeBottom != null ? Math.round(chromeBottom + GAP_PX) : null;

    if (cssTop != null && measuredMin != null) return Math.max(cssTop, measuredMin);
    if (cssTop != null) return cssTop;
    if (measuredMin != null) return measuredMin;

    return 96;
  }

  /** Bottom of main PLP column (toolbar + product grid + pagination), viewport px — filter must stay above this. */
  function getArticleFloorPx() {
    var pl = document.querySelector(
      'body.hmc-collection-carplay-kits .product-list.product-list--collection'
    );
    if (pl) {
      /* Stop at the last visible product card (not pagination / FAQ / footer). */
      try {
        var items = pl.querySelectorAll(':scope > .product-item');
        for (var i = items.length - 1; i >= 0; i--) {
          var r = items[i].getBoundingClientRect();
          if (r.width > 2 && r.height > 2) {
            return Math.round(r.bottom - 8);
          }
        }
      } catch (e) {}
      return Math.round(pl.getBoundingClientRect().bottom - 8);
    }
    var main = document.querySelector(
      'body.hmc-collection-carplay-kits section[data-section-type="collection"] .layout > .layout__section:not(.layout__section--secondary)'
    );
    if (main) {
      return Math.round(main.getBoundingClientRect().bottom - 10);
    }
    return window.innerHeight - 8;
  }

  /** Bottom of main PLP column in document px (used for bottom-stop). */
  function getArticleFloorDoc() {
    var y = window.scrollY || window.pageYOffset || 0;
    return y + getArticleFloorPx();
  }

  function clearDock(card, shell) {
    if (!card || !shell) return;
    var ph = shell.querySelector(':scope > .' + PH_CLASS);
    if (ph) {
      try {
        shell.removeChild(ph);
      } catch (e) {}
    }
    card.classList.remove(DOCKED_CLASS);
    card.classList.remove(BOTTOMED_CLASS);
    var form = card.querySelector('#desktop-filters-form');
    if (form) {
      form.style.removeProperty('max-height');
      form.style.removeProperty('overflow-y');
    }
    if (shell.dataset && shell.dataset.hmcDockPrevPos != null) {
      shell.style.position = shell.dataset.hmcDockPrevPos || '';
      delete shell.dataset.hmcDockPrevPos;
    }
    ['position', 'top', 'left', 'right', 'width', 'z-index', 'max-height'].forEach(function (p) {
      card.style.removeProperty(p);
    });
  }

  function applyDockLayout(card, shell) {
    if (!card.classList.contains(DOCKED_CLASS)) return;
    var topPx = dockTopPx();
    var sr = shell.getBoundingClientRect();
    card.style.zIndex = '30';

    /*
     * Desktop goal: never collapse the filters card and never add internal scrollbars.
     * Keep it fixed while products scroll, then bottom-stop at the last product card.
     */
    card.style.removeProperty('max-height');
    var form = card.querySelector('#desktop-filters-form');
    if (form) {
      form.style.removeProperty('max-height');
      form.style.overflowY = 'visible';
    }

    var scrollY = window.scrollY || window.pageYOffset || 0;
    var shellTopDoc = scrollY + sr.top;
    var floorDoc = getArticleFloorDoc();

    /* Ensure absolute bottom-stop is relative to the shell column. */
    try {
      var shellPos = window.getComputedStyle(shell).position;
      if (shellPos === 'static') {
        if (shell.dataset && shell.dataset.hmcDockPrevPos == null) {
          shell.dataset.hmcDockPrevPos = shell.style.position || '';
        }
        shell.style.position = 'relative';
      }
    } catch (e) {}

    var cardH = card.offsetHeight || card.scrollHeight || 0;
    if (!cardH || cardH < 40) {
      clearDock(card, shell);
      return;
    }

    /* If the card can't fit without inner scrollbars, don't dock it. */
    var avail = window.innerHeight - topPx - 16;
    if (cardH > avail + 2) {
      clearDock(card, shell);
      return;
    }

    var maxFixedScrollY = floorDoc - BOTTOM_GAP_PX - cardH - topPx;
    if (scrollY >= maxFixedScrollY) {
      /* Park at the bottom of the product grid (do not go into footer). */
      card.classList.add(BOTTOMED_CLASS);
      card.style.position = 'absolute';
      card.style.left = '0';
      card.style.right = '0';
      card.style.width = '100%';
      var topInShell = floorDoc - BOTTOM_GAP_PX - cardH - shellTopDoc;
      card.style.top = Math.max(0, Math.floor(topInShell)) + 'px';
    } else {
      /* Normal docked state. */
      card.classList.remove(BOTTOMED_CLASS);
      card.style.position = 'fixed';
      card.style.top = topPx + 'px';
      card.style.left = Math.round(sr.left) + 'px';
      card.style.right = '';
      card.style.width = Math.round(sr.width) + 'px';
    }
  }

  function syncPlaceholderSize(ph, card, shell) {
    if (!ph || !card || !shell) return;
    var sr = shell.getBoundingClientRect();
    ph.style.width = Math.round(sr.width) + 'px';
    ph.style.height = Math.round(card.offsetHeight) + 'px';
  }

  function tick() {
    raf = null;
    if (!isCarplayCollection()) return;

    try {
      mq = mq || window.matchMedia(DESKTOP_MQ);
    } catch (e) {
      return;
    }

    var shell = getShell();
    var card = shell && shell.querySelector(':scope > .card');
    if (!shell || !card || !shell.querySelector('#desktop-filters-form')) {
      if (card && shell) clearDock(card, shell);
      return;
    }

    if (!mq.matches) {
      clearDock(card, shell);
      return;
    }

    var line = dockTopPx();
    var ph = shell.querySelector(':scope > .' + PH_CLASS);

    if (!ph) {
      if (card.getBoundingClientRect().top < line) {
        var cardH = card.offsetHeight || card.scrollHeight || 0;
        var avail = window.innerHeight - line - 16;
        if (cardH && cardH > avail + 2) {
          clearDock(card, shell);
          return;
        }
        ph = document.createElement('div');
        ph.className = PH_CLASS;
        ph.setAttribute('aria-hidden', 'true');
        ph.style.flexShrink = '0';
        shell.insertBefore(ph, card);
        card.classList.add(DOCKED_CLASS);
        applyDockLayout(card, shell);
        var phAfter = shell.querySelector(':scope > .' + PH_CLASS);
        if (phAfter) syncPlaceholderSize(phAfter, card, shell);
      }
    } else {
      if (ph.getBoundingClientRect().top >= line) {
        clearDock(card, shell);
        return;
      }
      applyDockLayout(card, shell);
      ph = shell.querySelector(':scope > .' + PH_CLASS);
      if (ph) syncPlaceholderSize(ph, card, shell);
    }
  }

  function schedule() {
    if (raf != null) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      tick();
    });
  }

  function boot() {
    if (!isCarplayCollection()) return;
    schedule();
    [0, 80, 200, 500, 1200].forEach(function (ms) {
      window.setTimeout(schedule, ms);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(schedule, 0);
  });

  try {
    mq = window.matchMedia(DESKTOP_MQ);
    if (mq.addEventListener) mq.addEventListener('change', schedule);
    else if (mq.addListener) mq.addListener(schedule);
  } catch (e) {}

  document.addEventListener('theme:loading:end', schedule);

  if (typeof jQuery !== 'undefined') {
    jQuery(document).on('theme:loading:end', schedule);
  }
})();

/**
 * Revamp PDP: when customer selects Hamilton Guarantee Plus (radio) and clicks Add to cart, add kit + Guarantee Plus variant
 * in one `/cart/add.js` request (theme's default handler only adds the main line).
 */
(function () {
  function isRevampProductPage() {
    return (
      document.body.classList.contains('hmc-pdp-4runner-revamp') &&
      document.body.classList.contains('template-product')
    );
  }

  function warrantyPlusVariantId(form) {
    var root = form.querySelector('[data-hmc-warranty-plus-root]');
    if (!root) return 0;
    var raw = root.getAttribute('data-hmc-warranty-plus-variant-id') || '';
    var n = parseInt(raw, 10);
    return n > 0 ? n : 0;
  }

  function wantsPlus(form) {
    var sel = form.querySelector('input[name="hmc_warranty_plus_choice"]:checked');
    return !!(sel && sel.value === 'plus');
  }

  function mainVariantId(form) {
    var el = form.querySelector('[name="id"]');
    if (!el) return 0;
    var n = parseInt(el.value, 10);
    return n > 0 ? n : 0;
  }

  function qtyFromForm(form) {
    var el = form.querySelector('[name="quantity"]');
    if (!el) return 1;
    var n = parseInt(el.value, 10);
    return n > 0 ? n : 1;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (!isRevampProductPage()) return;
      var btn = e.target.closest('[data-action="add-to-cart"]');
      if (!btn || btn.disabled) return;
      var form = btn.closest('form[action*="/cart/add"]');
      if (!form || form.classList.contains('bundle-form')) return;
      if (!warrantyPlusVariantId(form) || !wantsPlus(form)) return;

      var mainId = mainVariantId(form);
      var wid = warrantyPlusVariantId(form);
      var qty = qtyFromForm(form);
      if (!mainId || !wid) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      var url = (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : '/cart') + '.js';
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      btn.setAttribute('disabled', 'disabled');

      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            { id: mainId, quantity: qty },
            { id: wid, quantity: qty },
          ],
        }),
      })
        .then(function (res) {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          btn.removeAttribute('disabled');
          if (!res.ok) {
            return res.json().then(function (err) {
              var msg = (err && (err.description || err.message)) || 'Could not add to cart';
              window.alert(msg);
              throw new Error(msg);
            });
          }
          return res.json();
        })
        .then(function () {
          var wpRoot = form.querySelector('[data-hmc-warranty-plus-root]');
          if (wpRoot) wpRoot.hidden = true;

          if (window.theme && window.theme.cartType === 'page' && window.routes && window.routes.cartUrl) {
            window.location.href = window.routes.cartUrl;
            return;
          }
          var sec = form.closest('section[data-section-type="product"]');
          if (sec) {
            sec.dispatchEvent(
              new CustomEvent('product:added', {
                bubbles: true,
                detail: { quantity: qty },
              })
            );
          }
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          btn.removeAttribute('disabled');
        });
    },
    true
  );
})();

/**
 * Stack-scroll product gallery (≥1000px): first four media only until “View more”. If the shopper picks a variant
 * whose featured image is beyond slot 4, auto-trigger the theme expand action so the image is not stuck hidden.
 */
(function () {
  function isDesktopWide() {
    try {
      return window.matchMedia("(min-width: 1000px)").matches;
    } catch (e) {
      return false;
    }
  }

  document.addEventListener("variant:changed", function (ev) {
    if (!isDesktopWide()) return;
    var detail = ev.detail || {};
    var variant = detail.variant;
    if (!variant || !variant.featured_media) return;
    var section = ev.target && ev.target.closest ? ev.target.closest('section[data-section-type="product"]') : null;
    if (!section) return;
    var stack = section.querySelector(".product-gallery--stack-scroll");
    if (!stack || stack.classList.contains("is-expanded")) return;
    var mid = String(variant.featured_media.id);
    var cell = section.querySelector('.product-gallery__carousel-item[data-media-id="' + mid + '"]');
    if (!cell || cell.classList.contains("is-filtered")) return;
    var ord = parseInt(cell.getAttribute("data-hmc-stack-ord") || "0", 10);
    if (ord > 4) {
      var btn = section.querySelector('[data-action="expand-product-media"]');
      if (btn) btn.click();
    }
  });

  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest('[data-action="expand-product-media"]');
    if (!btn) return;
    window.requestAnimationFrame(function () {
      var stack = btn.closest(".product-gallery--stack-scroll");
      if (stack && stack.classList.contains("is-expanded")) {
        btn.setAttribute("aria-expanded", "true");
      }
    });
  });
})();

/**
 * Pocket (≤999px): fullscreen mini-cart overlay (hamburger-style). Clears theme inline max-heights
 * that caused a narrow side strip; portaled to <body> for reliable fixed positioning.
 */
(function () {
  var POCKET_MQ = "(max-width: 999px)";
  var SCROLL_LOCK_CLASS = "hmc-mini-cart-open";
  var scrollLockY = 0;
  var touchBlocker = null;
  var cartScrollLocked = false;

  function isPocket() {
    try {
      return window.matchMedia(POCKET_MQ).matches;
    } catch (e) {
      return false;
    }
  }

  function miniCartEl() {
    return document.getElementById("mini-cart");
  }

  function cartHost() {
    return document.querySelector(".header__action-item--cart");
  }

  function portalMiniCart() {
    var mc = miniCartEl();
    if (!mc || !mc.classList.contains("hmc-mini-cart--fullscreen-pocket")) return;
    if (!isPocket()) {
      var host = cartHost();
      if (host && mc.parentNode === document.body) host.appendChild(mc);
      return;
    }
    if (mc.parentNode === document.body) return;
    document.body.appendChild(mc);
  }

  function clearThemeCartHeights(mc) {
    if (!mc) return;
    mc.style.maxHeight = "";
    mc.querySelectorAll(".mini-cart__content").forEach(function (el) {
      el.style.maxHeight = "";
    });
  }

  function closeMobileMenuIfOpen() {
    var menu = document.getElementById("mobile-menu");
    if (!menu || menu.getAttribute("aria-hidden") !== "false") return;
    var toggle = document.querySelector('[data-action="toggle-menu"][aria-expanded="true"]');
    if (toggle) toggle.click();
  }

  function lockPageScroll() {
    if (cartScrollLocked) return;
    scrollLockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("is-locked");
    document.body.classList.add("no-mobile-scroll", SCROLL_LOCK_CLASS);
    document.body.style.top = scrollLockY ? "-" + scrollLockY + "px" : "";
    document.body.style.width = "100%";
    cartScrollLocked = true;

    if (!touchBlocker) {
      touchBlocker = function (e) {
        var mc = miniCartEl();
        if (!mc || mc.getAttribute("aria-hidden") !== "false") return;
        if (mc.contains(e.target)) return;
        e.preventDefault();
      };
      document.addEventListener("touchmove", touchBlocker, { passive: false });
    }
  }

  function unlockPageScroll() {
    if (!cartScrollLocked) return;
    var restoreY = scrollLockY;
    document.documentElement.classList.remove("is-locked");
    document.body.classList.remove("no-mobile-scroll", SCROLL_LOCK_CLASS);
    document.body.style.top = "";
    document.body.style.width = "";
    cartScrollLocked = false;
    scrollLockY = 0;

    if (touchBlocker) {
      document.removeEventListener("touchmove", touchBlocker);
      touchBlocker = null;
    }

    if (restoreY > 0) {
      window.scrollTo(0, restoreY);
    }
  }

  function sanitizeStaleScrollLock() {
    var mc = miniCartEl();
    if (mc && mc.getAttribute("aria-hidden") === "false") return;
    if (
      !cartScrollLocked &&
      !document.body.classList.contains(SCROLL_LOCK_CLASS) &&
      !document.documentElement.classList.contains("is-locked") &&
      !document.body.style.top
    ) {
      return;
    }
    cartScrollLocked = false;
    scrollLockY = 0;
    document.documentElement.classList.remove("is-locked");
    document.body.classList.remove("no-mobile-scroll", SCROLL_LOCK_CLASS);
    document.body.style.top = "";
    document.body.style.width = "";
    if (touchBlocker) {
      document.removeEventListener("touchmove", touchBlocker);
      touchBlocker = null;
    }
  }

  function onCartVisibilityChange(mc) {
    if (!isPocket()) {
      if (cartScrollLocked) unlockPageScroll();
      return;
    }
    var open = mc.getAttribute("aria-hidden") === "false";
    if (open) {
      lockPageScroll();
      clearThemeCartHeights(mc);
      closeMobileMenuIfOpen();
      if (typeof window.hmcRemeasureHeader === "function") {
        window.hmcRemeasureHeader();
      }
      window.requestAnimationFrame(function () {
        clearThemeCartHeights(mc);
        if (typeof window.hmcRemeasureHeader === "function") {
          window.hmcRemeasureHeader();
        }
      });
      var closeBtn = mc.querySelector(".hmc-mini-cart__close");
      if (closeBtn) closeBtn.focus();
    } else if (cartScrollLocked) {
      unlockPageScroll();
      if (typeof window.hmcRemeasureHeader === "function") {
        window.hmcRemeasureHeader();
      }
    }
  }

  function bindMiniCartFullscreen() {
    var mc = miniCartEl();
    if (!mc || mc.dataset.hmcMiniCartFullscreenBound === "1") return;
    mc.dataset.hmcMiniCartFullscreenBound = "1";

    portalMiniCart();

    var mo = new MutationObserver(function (mutations) {
      portalMiniCart();
      var ariaChanged = false;
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === "aria-hidden") {
          ariaChanged = true;
          break;
        }
      }
      if (ariaChanged) {
        onCartVisibilityChange(mc);
      } else if (isPocket() && mc.getAttribute("aria-hidden") === "false") {
        clearThemeCartHeights(mc);
      }
    });
    mo.observe(mc, {
      attributes: true,
      attributeFilter: ["aria-hidden"],
    });

    document.addEventListener(
      "click",
      function (e) {
        if (!isPocket()) return;
        if (e.target.closest('[data-action="toggle-mini-cart"]')) {
          window.setTimeout(function () {
            clearThemeCartHeights(mc);
          }, 0);
          window.setTimeout(function () {
            clearThemeCartHeights(mc);
          }, 50);
        }
      },
      true
    );

    window.addEventListener(
      "resize",
      function () {
        portalMiniCart();
        if (isPocket() && mc.getAttribute("aria-hidden") === "false") {
          clearThemeCartHeights(mc);
        }
      },
      { passive: true }
    );

    var headerEl = document.querySelector(".header");
    if (headerEl && headerEl.dataset.hmcCartRerenderBound !== "1") {
      headerEl.dataset.hmcCartRerenderBound = "1";
      headerEl.addEventListener("cart:rerendered", function () {
        portalMiniCart();
        if (!isPocket()) return;
        var cart = miniCartEl();
        if (!cart || cart.getAttribute("aria-hidden") !== "false") return;
        lockPageScroll();
        clearThemeCartHeights(cart);
        window.requestAnimationFrame(function () {
          clearThemeCartHeights(cart);
        });
      });
    }
  }

  function init() {
    sanitizeStaleScrollLock();
    bindMiniCartFullscreen();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  window.addEventListener("pageshow", sanitizeStaleScrollLock);

  try {
    var mq = window.matchMedia(POCKET_MQ);
    if (mq.addEventListener) mq.addEventListener("change", init);
    else if (mq.addListener) mq.addListener(init);
  } catch (e) {}
})();

/**
 * Cart page — Guarantee Plus upsell (snippets/hmc-cart-warranty-upsell.liquid).
 * Adds the correct tier variant via /cart/add.js, then refreshes the cart section.
 */
(function () {
  var ROOT_SEL = "[data-hmc-cart-warranty-upsell]";
  var ADD_SEL = "[data-hmc-cart-warranty-add]";
  var ERR_SEL = "[data-hmc-cart-warranty-error]";

  function warmWarrantyBanner(modal) {
    if (!modal) return;
    var wrap = modal.querySelector(".hmc-cart-warranty-modal__banner-wrap");
    if (typeof window.hmcPreloadWarrantyMatrix === "function" && wrap) {
      window.hmcPreloadWarrantyMatrix(wrap);
    }
  }

  function setError(root, message) {
    var el = root && root.querySelector(ERR_SEL);
    if (!el) return;
    if (message) {
      el.textContent = message;
      el.hidden = false;
    } else {
      el.textContent = "";
      el.hidden = true;
    }
  }

  function setBusy(btn, busy) {
    if (!btn) return;
    if (busy) {
      btn.disabled = true;
      btn.setAttribute("aria-busy", "true");
    } else {
      btn.disabled = false;
      btn.removeAttribute("aria-busy");
    }
  }

  /** Theme skips cart DOM updates when cartType is "page"; refresh the section ourselves. */
  function refreshCartPageSection() {
    var cartSection = document.querySelector('[data-section-type="cart"]');
    if (!cartSection) return Promise.resolve();

    var sectionId = cartSection.getAttribute("data-section-id");
    if (!sectionId) return Promise.resolve();

    var cartUrl = (window.routes && window.routes.cartUrl) || "/cart";
    var url = cartUrl + "?section_id=" + encodeURIComponent(sectionId);

    return fetch(url, {
      credentials: "same-origin",
      method: "GET",
      headers: { "Cache-Control": "no-cache" },
    })
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var temp = document.createElement("div");
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-section-type="cart"]');
        if (!fresh) return;

        cartSection.innerHTML = fresh.innerHTML;

        var itemCount = fresh.getAttribute("data-item-count");
        if (itemCount != null) {
          cartSection.setAttribute("data-item-count", itemCount);
          document.querySelectorAll(".header__cart-count").forEach(function (el) {
            el.textContent = itemCount;
          });
        }

        document.dispatchEvent(
          new CustomEvent("cart:rerendered", { bubbles: true })
        );
      });
  }

  function addWarranty(root, btn) {
    var variantId = parseInt(btn.getAttribute("data-variant-id"), 10);
    var quantity = parseInt(btn.getAttribute("data-quantity"), 10);
    if (!variantId || !quantity || quantity < 1) return;

    setError(root, "");
    setBusy(btn, true);
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    var addUrl =
      (window.routes && window.routes.cartAddUrl ? window.routes.cartAddUrl : "/cart/add") +
      ".js";

    fetch(addUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          var msg =
            (result.data && (result.data.description || result.data.message)) ||
            "Could not add warranty to cart.";
          setError(root, msg);
          setBusy(btn, false);
          return Promise.reject(new Error("hmc-warranty-add-failed"));
        }
        return refreshCartPageSection();
      })
      .catch(function (err) {
        if (!err || err.message !== "hmc-warranty-add-failed") {
          setError(root, "Could not add warranty to cart.");
          setBusy(btn, false);
        }
      })
      .finally(function () {
        document.dispatchEvent(new CustomEvent("theme:loading:end"));
      });
  }

  function bindRoot(root) {
    if (!root || root.dataset.hmcCartWarrantyBound === "1") return;
    root.dataset.hmcCartWarrantyBound = "1";

    var detailsBtn =
      root.querySelector(".hmc-cart-warranty-upsell__help") ||
      root.querySelector(".hmc-cart-warranty-upsell__details-link");
    var modalId =
      detailsBtn?.getAttribute("aria-controls") ||
      root.closest("[data-section-type='cart']")?.querySelector(".hmc-cart-warranty-upsell__details-link")?.getAttribute("aria-controls");
    var modal = modalId && document.getElementById(modalId);

    if (detailsBtn) {
      ["mousedown", "touchstart", "focus"].forEach(function (evt) {
        detailsBtn.addEventListener(
          evt,
          function () {
            warmWarrantyBanner(modal);
          },
          { passive: true, once: evt === "focus" }
        );
      });
    }

    root.addEventListener("click", function (e) {
      var btn = e.target.closest(ADD_SEL);
      if (!btn || !root.contains(btn)) return;
      e.preventDefault();
      addWarranty(root, btn);
    });
  }

  function scan() {
    document.querySelectorAll(ROOT_SEL).forEach(bindRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  document.addEventListener("cart:rerendered", scan);
  document.addEventListener("shopify:section:load", scan);
})();

/**
 * Homepage hero headline: keep “Make Every Drive Feel New.” on one line inside the CTA band (pocket).
 */
(function () {
  var POCKET_MQ = "(max-width: 999px)";
  var HEADING_SEL =
    "body.template-index section[data-section-type='header'] .hmc-header-rivian-spine--home .hmc-hero-cta__heading";
  var CTA_SEL =
    "body.template-index section[data-section-type='header'] .hmc-header-rivian-spine--home .hmc-hero-cta";

  function fitHomeHeroHeading() {
    if (!document.body.classList.contains("template-index")) return;
    var heading = document.querySelector(HEADING_SEL);
    var cta = document.querySelector(CTA_SEL);
    if (!heading || !cta) return;

    if (!window.matchMedia(POCKET_MQ).matches) {
      heading.style.fontSize = "";
      return;
    }

    var maxWidth = cta.clientWidth;
    if (maxWidth < 1) return;

    heading.style.whiteSpace = "nowrap";
    heading.style.maxWidth = "100%";

    var sizePx = 24;
    var minPx = 10;
    heading.style.fontSize = sizePx + "px";

    while (heading.scrollWidth > maxWidth && sizePx > minPx) {
      sizePx -= 0.5;
      heading.style.fontSize = sizePx + "px";
    }
  }

  var raf = null;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = null;
      fitHomeHeroHeading();
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule);
  } else {
    schedule();
  }
  window.addEventListener("load", schedule);
  window.addEventListener("resize", schedule, { passive: true });

  try {
    var mq = window.matchMedia(POCKET_MQ);
    if (mq.addEventListener) mq.addEventListener("change", schedule);
    else if (mq.addListener) mq.addListener(schedule);
  } catch (e) {}

  document.addEventListener("shopify:section:load", schedule);

  document.addEventListener(
    "animationend",
    function (e) {
      if (e.target && e.target.closest && e.target.closest(".hmc-hero-cta")) schedule();
    },
    true
  );

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule).catch(function () {});
  }
})();

/**
 * Collection PLP (mobile): lock page scroll while Sort By or Filter sheet is open;
 * cap filter drawer height for bottom-sheet layout. Re-bind after AJAX pagination/filter refresh.
 */
(function () {
  var POCKET_MQ = "(max-width: 999px)";
  if (!document.body.classList.contains("template-collection")) return;

  var sortPicker = null;
  var filterDrawer = null;
  var scrollY = 0;
  var touchBlocker = null;
  var ariaObservers = [];

  function isPocket() {
    return window.matchMedia(POCKET_MQ).matches;
  }

  function isSortOpen() {
    return sortPicker && sortPicker.getAttribute("aria-hidden") === "false";
  }

  function isFilterOpen() {
    return filterDrawer && filterDrawer.getAttribute("aria-hidden") === "false";
  }

  function shouldLock() {
    return isPocket() && (isSortOpen() || isFilterOpen());
  }

  function sanitizePlpScrollLock() {
    var headerSection = document.querySelector(".shopify-section__header");
    if (headerSection) headerSection.style.zIndex = "";

    document.documentElement.classList.remove("is-locked");
    document.body.classList.remove("hmc-plp-overlay-locked", "no-mobile-scroll");
    document.body.style.top = "";
    document.body.style.width = "";
    document.body.style.position = "";
    scrollY = 0;

    if (touchBlocker) {
      document.removeEventListener("touchmove", touchBlocker);
      touchBlocker = null;
    }
  }

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    var toggle = document.querySelector('[aria-controls="mobile-collection-filters"]');
    if (toggle) toggle.setAttribute("aria-expanded", "false");
    filterDrawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("no-mobile-scroll");
    syncScrollLock();
  }

  function lockScroll() {
    if (!shouldLock() || document.body.classList.contains("hmc-plp-overlay-locked")) return;
    scrollY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add("is-locked");
    document.body.classList.add("hmc-plp-overlay-locked");
    /* Avoid position:fixed + negative top on body — misaligns taps inside transformed bottom sheets on iOS. */
    document.body.style.width = "100%";

    if (!touchBlocker) {
      touchBlocker = function (e) {
        var target = e.target;
        if (sortPicker && sortPicker.getAttribute("aria-hidden") === "false" && sortPicker.contains(target)) {
          return;
        }
        if (filterDrawer && filterDrawer.getAttribute("aria-hidden") === "false" && filterDrawer.contains(target)) {
          return;
        }
        e.preventDefault();
      };
      document.addEventListener("touchmove", touchBlocker, { passive: false });
    }
  }

  function unlockScroll() {
    if (!document.body.classList.contains("hmc-plp-overlay-locked")) return;
    if (shouldLock()) return;

    var restoreY = scrollY;
    sanitizePlpScrollLock();

    if (restoreY > 0) {
      window.scrollTo(0, restoreY);
    }
  }

  function syncScrollLock() {
    if (shouldLock()) lockScroll();
    else unlockScroll();
  }

  function capFilterDrawerHeight() {
    if (!filterDrawer || !isPocket()) return;
    var panel = filterDrawer.querySelector(".collection-drawer");
    if (!panel) return;
    panel.style.maxHeight = Math.min(window.innerHeight * 0.92, 720) + "px";
  }

  function disconnectAriaObservers() {
    ariaObservers.forEach(function (obs) {
      try {
        obs.disconnect();
      } catch (e) {}
    });
    ariaObservers = [];
  }

  function observeAriaHidden(el) {
    if (!el || typeof MutationObserver === "undefined") return;
    var obs = new MutationObserver(syncScrollLock);
    obs.observe(el, { attributes: true, attributeFilter: ["aria-hidden"] });
    ariaObservers.push(obs);
  }

  function bindPlpOverlayNodes() {
    disconnectAriaObservers();
    sortPicker = document.getElementById("sort-by-selector");
    filterDrawer = document.getElementById("mobile-collection-filters");
    observeAriaHidden(sortPicker);
    observeAriaHidden(filterDrawer);
    syncScrollLock();
  }

  bindPlpOverlayNodes();

  document.addEventListener(
    "click",
    function (e) {
      if (e.target.closest('[data-action="open-drawer"][aria-controls="mobile-collection-filters"]')) {
        window.requestAnimationFrame(capFilterDrawerHeight);
        return;
      }

      if (!filterDrawer || filterDrawer.getAttribute("aria-hidden") !== "false") return;

      if (e.target.closest("#mobile-collection-filters [data-action=\"close-drawer\"]")) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeFilterDrawer();
        return;
      }

      /* Dimmed backdrop (drawer root / ::before area), not the sheet panel */
      if (
        e.target === filterDrawer ||
        (filterDrawer.contains(e.target) && !e.target.closest(".drawer__inner"))
      ) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closeFilterDrawer();
      }
    },
    true
  );

  document.addEventListener("theme:loading:end", function () {
    sanitizePlpScrollLock();
    bindPlpOverlayNodes();
  });

  window.addEventListener("resize", capFilterDrawerHeight, { passive: true });
})();

/**
 * Homepage CarPlay make rows: one-line shelf title (+ View More chip on desktop).
 */
(function () {
  var POCKET_MQ = '(max-width: 999px)';
  var DESKTOP_MQ = '(min-width: 1000px)';
  var LINK_SEL =
    'body.template-index [data-section-type="hmc-home-carplay-make-rows"] .hmc-home-carplay-make-rows__shelf-title-link';
  var DESKTOP_TITLE_SEL =
    'body.template-index [data-section-type="hmc-home-carplay-make-rows"] .hmc-home-carplay-make-rows__shelf-head-desktop .hmc-home-carplay-make-rows__shelf-title';

  function fitCarplayShelfTitles() {
    if (!document.body.classList.contains('template-index')) return;
    var links = document.querySelectorAll(LINK_SEL);
    if (!links.length) return;

    if (!window.matchMedia(POCKET_MQ).matches) {
      links.forEach(function (link) {
        var titleEl = link.closest('.hmc-home-carplay-make-rows__shelf-title');
        if (titleEl) titleEl.style.fontSize = '';
      });
      return;
    }

    links.forEach(function (link) {
      var titleEl = link.closest('.hmc-home-carplay-make-rows__shelf-title');
      var text = link.querySelector('.hmc-home-carplay-make-rows__shelf-title-text');
      if (!titleEl || !text) return;

      var head = link.closest('.hmc-home-carplay-make-rows__shelf-head');
      var maxWidth = (head && head.clientWidth) || link.clientWidth;
      if (maxWidth < 1) return;

      text.style.whiteSpace = 'nowrap';

      var sizePx = 17;
      var minPx = 10;
      titleEl.style.fontSize = sizePx + 'px';

      while (link.scrollWidth > maxWidth + 1 && sizePx > minPx) {
        sizePx -= 0.5;
        titleEl.style.fontSize = sizePx + 'px';
      }
    });
  }

  function fitCarplayShelfDesktopTitles() {
    if (!document.body.classList.contains('template-index')) return;
    var titles = document.querySelectorAll(DESKTOP_TITLE_SEL);
    if (!titles.length) return;

    if (!window.matchMedia(DESKTOP_MQ).matches) {
      titles.forEach(function (titleEl) {
        titleEl.style.fontSize = '';
      });
      return;
    }

    titles.forEach(function (titleEl) {
      var text = titleEl.querySelector('.hmc-home-carplay-make-rows__shelf-title-text');
      if (!text) return;

      var head = titleEl.closest('.hmc-home-carplay-make-rows__shelf-head');
      var maxWidth = (head && head.clientWidth) || titleEl.clientWidth;
      if (maxWidth < 1) return;

      text.style.whiteSpace = 'nowrap';

      var computed = window.getComputedStyle(titleEl);
      var sizePx = parseFloat(computed.fontSize) || 23;
      var minPx = 14;
      titleEl.style.fontSize = sizePx + 'px';

      while (titleEl.scrollWidth > maxWidth + 1 && sizePx > minPx) {
        sizePx -= 0.5;
        titleEl.style.fontSize = sizePx + 'px';
      }
    });
  }

  var raf = null;
  function schedule() {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function () {
      raf = null;
      fitCarplayShelfTitles();
      fitCarplayShelfDesktopTitles();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  window.addEventListener('load', schedule);
  window.addEventListener('resize', schedule, { passive: true });

  try {
    [POCKET_MQ, DESKTOP_MQ].forEach(function (query) {
      var mq = window.matchMedia(query);
      if (mq.addEventListener) mq.addEventListener('change', schedule);
      else if (mq.addListener) mq.addListener(schedule);
    });
  } catch (e) {}

  document.addEventListener('shopify:section:load', schedule);

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(schedule).catch(function () {});
  }
})();

/**
 * 4Runner PDP hero share flyout (<details>): click/tap anywhere outside to close
 * (not only the share icon again).
 */
(function () {
  function is4rPdp() {
    return (
      document.body.classList.contains('hmc-pdp-4runner-revamp') &&
      document.body.classList.contains('template-product')
    );
  }

  function openShareFlyouts() {
    return document.querySelectorAll('.hmc-pdp-revamp-hero__share-flyout[open]');
  }

  function closeShareFlyouts() {
    openShareFlyouts().forEach(function (details) {
      details.removeAttribute('open');
    });
  }

  function clickInsideOpenFlyout(target) {
    if (!target || !target.closest) return false;
    var flyouts = openShareFlyouts();
    for (var i = 0; i < flyouts.length; i++) {
      if (flyouts[i].contains(target)) return true;
    }
    return false;
  }

  function onPointerOutside(event) {
    if (!is4rPdp()) return;
    if (!openShareFlyouts().length) return;
    if (clickInsideOpenFlyout(event.target)) return;
    closeShareFlyouts();
  }

  function bindShareFlyouts() {
    if (!is4rPdp()) return;

    document.querySelectorAll('.hmc-pdp-revamp-hero__share-flyout').forEach(function (details) {
      if (details.dataset.hmcShareFlyoutBound === '1') return;
      details.dataset.hmcShareFlyoutBound = '1';

      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeShareFlyouts();
        }
      });
    });
  }

  function initShareFlyoutDismiss() {
    bindShareFlyouts();

    if (document.documentElement.dataset.hmcShareFlyoutOutsideBound === '1') return;
    document.documentElement.dataset.hmcShareFlyoutOutsideBound = '1';

    document.addEventListener('click', onPointerOutside, true);
    document.addEventListener('touchstart', onPointerOutside, { capture: true, passive: true });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeShareFlyouts();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShareFlyoutDismiss);
  } else {
    initShareFlyoutDismiss();
  }

  document.addEventListener('shopify:section:load', initShareFlyoutDismiss);
})();

(function () {
  function wrapReadableTables() {
    var selector =
      '.shopify-policy__body table, .shopify-policy__container table, section.hmc-page-prose .page__content table';
    document.querySelectorAll(selector).forEach(function (table) {
      var parent = table.parentElement;
      if (!parent || parent.classList.contains('table-wrapper')) return;
      var wrap = document.createElement('div');
      wrap.className = 'table-wrapper';
      parent.insertBefore(wrap, table);
      wrap.appendChild(table);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wrapReadableTables);
  } else {
    wrapReadableTables();
  }
})();

(function () {
  var TOS_RETURNS_OLD =
    'For full details on our returns and refunds, please review our Return Policy and Warranty Policy on our Support page, available at https://www.hamiltonmotorcompany.com/pages/support.';
  var TOS_RETURNS_NEW =
    'For full details on our returns and refunds, please review our Return Policy and Warranty Policy.';

  function patchTermsOfServiceReturnsCopy() {
    if (!document.body.classList.contains('template-policy')) return;
    if (window.location.pathname.indexOf('/policies/terms-of-service') === -1) return;
    var root = document.querySelector('.shopify-policy__body');
    if (!root || root.innerHTML.indexOf(TOS_RETURNS_OLD) === -1) return;
    root.innerHTML = root.innerHTML.split(TOS_RETURNS_OLD).join(TOS_RETURNS_NEW);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchTermsOfServiceReturnsCopy);
  } else {
    patchTermsOfServiceReturnsCopy();
  }
})();
